/*!
 * Manera Product List
 * 
 */
$(document).ready(function(){
    /** ANIM PARALLAX COMBI **/

    //couleurs produits liste produits
    if($('.mod_maneralist ').length > 0
        || $('.athlete__products ').length > 0
        || $('.mod_manerareader').length>0){
        $('li.couleur').on('click',function(e){
            var item = $(this).data('item');
            //var bg = "#"+$(this).data('bg');
            //TweenMax.to('#wrapper',.5,{backgroundColor: bg,ease:Power3.easeOut});

            var product = $('#'+item);
            var siblings = product.siblings();

            siblings.removeClass('d-block').addClass('d-none');
            product.removeClass('d-none').addClass('d-block');
        });
    }
    if($('.mod_maneralist ').length > 0)
    {
        $('li.couleur').on('click',function(e){
            var item = $(this).data('item');
            var color_id = $(this).data('gcolor');
            var product = $('#'+item).closest('.layout_simple');
            var link = product.find('h3 a');
            var links = product.find('a');
            var href = link.prop('href');//link.data('url');

            href += "?color="+color_id;
            links.prop('href',href);
        });
    }

    /*** LISTE PRODUIT TITLE ANIM**/
    var controller = new ScrollMagic.Controller();
    var scene = new ScrollMagic.Scene({
        triggerElement: '#container',
        duration: "100%",
    })
        .setTween('.main-title', 1,{opacity:0})
        .addTo(controller);

    /** ANIM etiquette men/women **/

    var controllerEtiquette = new ScrollMagic.Controller();
    var menLabel = $('.gamme.men').find('.genre').first();
    var menLabelParent = menLabel.parent();
    var womenLabel = $('.gamme.women').find('.genre').first();
    var womenLabelParent = womenLabel.parent();

    var menTag = new ScrollMagic.Scene({
        triggerElement: menLabel,
        triggerHook: 0.2,
    }).setClassToggle(menLabelParent,'active')
        .setPin(menLabel)
        .addTo(controllerEtiquette);

    var womenTag = new ScrollMagic.Scene({
        triggerElement: womenLabel,
        triggerHook:0.2,
    }).setClassToggle(womenLabelParent,'active')
        .setPin(womenLabel)
        .on('start',function(){
            menLabelParent.toggleClass('hideleft');
        })
        .addTo(controllerEtiquette);

    /*** handle color to product (ex : harnesses) **/
    if($('.colortoproduct').length > 0)
    {
        var colortoproducts = $('.colortoproduct');
        colortoproducts.each(function(index){
            var products = $(this).find('.product')
            //products.find('photos ul').removeClass('d-block').addClass('d-none');
            //products.find('.details li').removeClass('d-block').addClass('d-none');
            products.each(function(index){
                var photos = $(this).find('.photos ul');
                var color = $(this).find('.details li');
                $(photos[index]).addClass('d-block');
                $(color[index]).addClass('d-inline-block');
            })
        })

        var newcolors = $('.newcolor');
        _.each(newcolors,function(color){
            if($(color).hasClass('d-inline-block'))
                $(color).parent().prev().find('.new').removeClass('d-none');
        });
    }

    /*** filters **/
    if($('#filtres').length > 0 )
    {
        //animation depliage des filtres
        $('.filters').hover( function(){
            //console.log('hover');
            var fh = $('.filters').find('.inner').outerHeight(true);
            TweenMax.to('.filters', .5,{height:fh+'px', ease: Power2.easeOut});
        }, function(){
            //console.log('out');
            TweenMax.to('.filters', .5,{height:'60px', ease: Power2.easeOut});
        });

        //boutons FT /CM
        $('.switch').find(':checked').parent().addClass('active');

        $('.switch').find('input').on('change', function(){
            $('.switch').find('label').removeClass('active');
            if($(this).is(':checked')){
                $(this).parent().addClass('active');
            }
            var switchBtn = $(this).prop('value');
            $('.widget.ft,.widget.cm').removeClass('active');
            $('.widget.'+switchBtn).addClass('active');
        });
        //
        if($('body').hasClass('mobile') || $('body').hasClass('tablet'))
        {
            $('#filtres').find('h2').on('click',function(){
                var $this = $(this).closest('#filtres');
                $this.toggleClass('active');
                if($this.hasClass('active'))
                    TweenMax.to($this,.5,{maxHeight:'50px', ease: Power2.easeOut});
                else
                    TweenMax.to($this,.5,{maxHeight:$this.find('.inside').height(), ease: Power2.easeOut});

            })
        }

        if(!$('body').hasClass('mobile') && !$('body').hasClass('tablet'))
        {
            var cb = $('.cookiebar:visible');
            var ch = cb.outerHeight();
            var offset = $('.header').height();
            var filtresController = new ScrollMagic.Controller();
            if(cb.length > 0)
            {
                var offset = offset+ch;
            }
            var filtresScene = new ScrollMagic.Scene({
                triggerElement: '#filtres',
                triggerHook: "onLeave",
                offset: "-55px",//-offset, //"-55px",
            }).setPin('#filtres').addTo(filtresController);
        }

        var widgets = $('.filters').find('.widget');
        widgets.each(function(){
            var checked = $(this).find('input:checked');
            if(checked.length > 0)
                $(this).addClass('active');
            else
                $(this).removeClass('active');
        });

        $('.filters input[type="checkbox"],.filters input[type="radio"]').on('click',function(e){

            var widget = $(this).closest('.widget');
            var checkboxes = widget.find('input[type="checkbox"], input[type="radio"]');

            var checked = false;

            checkboxes.each(function(i){
                if($(this).is(':checked')) {
                    checked = true;
                }
            });

            if(checked)
                widget.addClass('active');
            else
                widget.removeClass('active');
        });

        var filter_form =  $('.filters form');
        //var initialMarkup = $('.mod_maneralist').html();

        filter_form.submit(function(e){
            e.preventDefault();
        });

        /**** LIEN RESET FILTRES ***/

        $('.reset a').on('click',function(e){
            e.preventDefault();
            reset();

        });

        /**** FILTRE LES RESULTATS ***/
        var gammes = $('.gamme');
        var products = $('.products').find('.product');
        var objProducts = [];
        var filtered = [];
        var sorting = "";
        initFilters();
        initProducts();


        filter_form.find(':checkbox,:radio').on('change',function()
        {
            var sortby = $('.filters').find('input[name="sort_by[]"]');
            var update = countChecked();

            if( update > 0)
            {
                $('.filters h2').find('span span').text("("+update+")");
            }else {
                $('.filters h2').find('span span').text("");
            }

            //si on check sort_by ou si deja check
            if($(this).prop('name') == "sort_by[]")
            {
                if($('.filters input[name="sort_by[]"]').not(this).is(':checked'))
                    $('.filters h2').find('span span').text("("+(update-1)+")");

                $('.filters input[name="sort_by[]"]').not(this).prop('checked',false);

                removeOrdering();
                orderProducts($(this).prop('value'));
            }
            else if($(this).prop('name') == "units") //switch ft/cm
            {
                var activeWidget = $('.size').find('.widget').not('.switch').not('d-none');
                var switch_units = $(this).prop('value');
                $('.widget.ft, .widget.cm').addClass('d-none');

                var widget = $('.widget.'+switch_units+',fieldset.'+switch_units).removeClass('d-none');
                var unitsChecked = getCheckedUnits(activeWidget);
                setCheckedUnits(widget,unitsChecked)
            }
            else {
                reloadProducts();
                if(sortby.is(':checked')){
                    removeOrdering();
                    orderProducts(sortby.prop('value'));
                }

                //orderProducts(sortby.prop('value'));*/
            }


        });
        function getCheckedUnits(widget)
        {
            var checked = [];
            var inputs = widget.find(':checked');
            _.each(inputs,function(element){
                var num = Number($(element).prop('id').split('_')[2]);
                checked.push(num);
            });
            unCheck(widget);
            return checked;
        }

        function setCheckedUnits(widget,unitsChecked)
        {

            var inputs = widget.find('input.checkbox');
            _.each(inputs, function(element){
               var num = Number($(element).prop('id').split('_')[2]);
               //console.log(num+" / "+unitsChecked+" / "+_.indexOf(unitsChecked,num));
               if(_.indexOf(unitsChecked,num) != -1)
               {
                   $(element).prop('checked','checked');
               }
            });
        }
        function unCheck(widget)
        {
            var inputs = widget.find('input:checked');
            inputs.prop('checked',false);
        }
        function initFilters()
        {
            var value = $('.switch').find(':checked').prop('value');
            $('.widget.'+value+',fieldset.'+value).removeClass('d-none');
        }

        function initProducts()
        {
            objProducts = [];
            products.each(function(){
                var obj = getProductAttributes(this);
                objProducts.push(obj);
            });
            //console.log(objProducts);
        }

        function reloadProducts()
        {
            products.addClass('d-none');
            filtered = [];
            var selected = findChecked();
            if(!_.isEmpty(selected)) {

                _.each(selected, getProduct);//on rempli filtered ds getProduct

                var filteredProducts = _.intersection.apply(_, filtered);
                applyFilters(filteredProducts);
            }else {
                showAll();
            }
            //showBreakers();
            hideGhostBreaker();

           //var visible = $('.products').find('.product').not('.d-none');
           var visibles = $('.products .product:not(.d-none)');
           var visibleGammes = $('.gamme').not('.d-none');

           _.each(visibleGammes, function(gamme){
                var visibleProducts = $(gamme).find('.product:not(.d-none)');
                var i = 1;
                var j = 1;

                _.each(visibleProducts, function(product){

                    if(i < 2)
                    {
                        j = 1;
                        i++;
                    }
                    else if(i == 2 && j == 1){
                        $('<div class="injected w-100"/>').insertAfter($(product));
                        j++;
                    }
                    else if(i == 2 && j < 4)
                    {
                        j++;
                    }else if(j == 4 && i ==2) {
                        $('<div class="injected w-100"/>').insertAfter($(product));
                        i= 1;
                        j=1;
                    }
                });

           });
        }

        function orderProducts(sortBy) {
            var dataSort = "data-" + sortBy.toLowerCase();
            var visibleGammes = $('.gamme').not('.d-none');
            var byGammes = [];
            var sortedProducts;


            visibleGammes.each(function () {
                var products = $(this).find('.product').not('.d-none');
                sortedProducts = [];
                products.each(function () {
                    var obj = getProductAttributes(this);
                    sortedProducts.push(obj);
                });
                var sorted = _.sortBy(sortedProducts,function(product){
                    return product[dataSort];
                }).reverse();
                byGammes.push(sorted);
            });
            reOrder(byGammes);
        }

        function getProduct(item, index, list) {

            //item = value du filtre selectionné
            //index = nom du data attribute a check
            if (index != "sort_by" && index != "units") {
                index = "data-" + index;

                var newProducts = _.filter(objProducts, function (product) {
                    if(product[index] == undefined)
                        return false;
                    var name = product[index].toString();
                    if (name.indexOf("|") > -1) // plusieurs valeurs separees par |
                    {
                        var values = name.split('|');
                        var match = _.intersection(values, item);
                        if (match.length > 0)
                            return true;
                        //return _.contains(values,item.toString());
                    }
                    else {
                        //item = Number(item);
                    }

                    return _.contains(item, name);
                });
                /*console.log("nweproducts");
                console.log(newProducts);*/
                filtered.push(newProducts);
            }
        }

        function getProductAttributes ( node ) {
            return _.reduce( node.attributes, function ( attrs, attribute ) {
                //console.log(attribute.name);
                if(attribute.name != "data-thickness"
                    || attribute.name != "data-size_cm"
                    || attribute.name != "data-size_ft")
                    attrs[attribute.name] = (isNumeric(attribute.value))? +attribute.value : attribute.value;
                else
                    attrs[attribute.name] = attribute.value;
                return attrs;
            }, {} );
        }

        function isNumeric(num)
        {
            num = +num;
            if(!isNaN(num))
                return true;
            return false;
        }

        function applyFilters(zeProducts)
        {
            //console.log(zeProducts);
            _.each(zeProducts,function(item, index){
                $('#'+item.id).removeClass('d-none');
            });

            hideGammesIfNoProducts();
        }

        function findChecked()
        {
            var selected = {};
            var radio = $('.filters').find(':radio:checked');
            var checkboxes = $('.filters').find(':checkbox:checked');

            radio.each(function(){
                var name= $(this).prop('name');
                var value = $(this).prop('value');

                if(name != "sort_by" && name != "units")
                    selected[name] = [value];
            })

            checkboxes.each(function(){
                var name = this.name.replace("[]","");
                if(name != 'units')
                {
                    if (!selected.hasOwnProperty(name))
                        selected[name] = [this.value];
                    else
                        selected[name].push(this.value);
                }
            });

            return selected;

        }
        function countChecked()
        {
            var filters = $('.filters').find('.widget').not('.switch').find(':checked');

            return filters.length;
        }

        function hideGammesIfNoProducts()
        {
            var gammes = $('.gamme');

            gammes.each(function(){
                var gamme = $(this);
                var products = gamme.find('.product').not('.d-none');

                if(products.length > 0) {
                    gamme.removeClass('d-none');
                    gamme.find('.combi').removeClass('d-none');
                }
                else {
                    gamme.addClass('d-none');
                    gamme.find('.combi').addClass('d-none');
                }
            });

        }

        function reOrder(gammes) {
            //console.log(gammes);
            _.each(gammes, function (value) {
                var order = 1;
                //on chope le parent des produits de la gamme, ici une row bootstrp, et on chercher le separateur
                //et on recup son index, pour l'insérer à la meme place ds le nouvel objet.
                var row = $("#"+value[0].id).parent();
                var breaker = row.find('.w-100');
                var breakerIndex = row.find('> div').index(breaker);
                var objBreaker = {};
                objBreaker.class = "w-100";

                if(value.length > breakerIndex) {
                    value.splice(breakerIndex, 0, objBreaker);
                    breaker.removeClass('d-none');
                }
                else
                    breaker.addClass('d-none');

                //console.log(value);
                _.each(value, function (val, key) {

                    if(val.class == "w-100")
                        var product_id = $('.'+val.class);
                    else
                        var product_id = $("#" + val.id);

                    product_id.addClass('order-' + order);
                    order = order+1;
                });
                //console.log('###changement gamme###');
            })
        }

        function hideGhostBreaker()
        {
            //console.log('hide breakers');
            $('.injected').remove();
           $('.products').find('.w-100').addClass('d-none');
        }

        function showBreakers()
        {
            var hiddenBreakers = $('.products').find('.w-100.d-none');
            hiddenBreakers.removeClass('d-none');
        }

        function reset()
        {
            filter_form.find('input[type="radio"], input[type="checkbox"]').prop('checked',false);
            filter_form.find('.widget').removeClass('active');
            $('.filters h2').find('span span').text("");
            if($('.switch').length > 0)
            {
                filter_form.find('input[value="ft"]').prop('checked', true);
                $('.widget.ft,fieldset.ft').removeClass('d-none');
                $('.widget.cm,fieldset.cm').addClass('d-none');
            }
            showAll();
            removeOrdering();
        }
        function showAll()
        {
            products.removeClass('d-none');
            gammes.removeClass('d-none');
            $('.combi').removeClass('d-none');
            $('.injected').remove();
            $('.products').find('.w-100').removeClass('d-none');
        }

        function removeOrdering()
        {
            $('.w-100').removeClass(function (index, css) {
                return (css.match (/\order-\S+/g) || []).join(' '); // removes anything that starts with "order-"
            });
            products.removeClass(function (index, css) {
                return (css.match (/\order-\S+/g) || []).join(' '); // removes anything that starts with "order-"
            });
        }

    }
});